import { Box, Collapsible, HStack, Text } from "@chakra-ui/react";
import * as React from "react";
import { LuChevronDown, LuHistory } from "react-icons/lu";

interface ActivityLogProps {
  title?: string;
  meta?: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

export function ActivityLog({
  children,
  defaultOpen = false,
  meta,
  title = "Activity log",
}: ActivityLogProps) {
  return (
    <Collapsible.Root
      background="bg.subtle"
      borderRadius="l3"
      boxShadow="table"
      defaultOpen={defaultOpen}
      overflow="hidden"
    >
      <Collapsible.Trigger asChild>
        <HStack
          cursor={"pointer" as any}
          gap="3"
          height="14"
          paddingX="4"
          userSelect="none"
          width="full"
          css={{
            "&[data-state=open] .activity-log-chevron": {
              transform: "rotate(180deg)",
            },
          }}
        >
          <Box color="fg.ink" flexShrink="0">
            <LuHistory size="20" />
          </Box>
          <Text
            color="fg.ink"
            fontSize="lg"
            fontWeight="medium"
            lineHeight={"28px" as any}
          >
            {title}
          </Text>
          <Box
            className="activity-log-chevron"
            color="fg.ink"
            flexShrink="0"
            transition={"transform 0.18s ease" as any}
          >
            <LuChevronDown size="16" />
          </Box>
          {meta && (
            <Text color="fg.muted" fontSize="sm" marginLeft={"auto" as any}>
              {meta}
            </Text>
          )}
        </HStack>
      </Collapsible.Trigger>
      <Collapsible.Content>{children}</Collapsible.Content>
    </Collapsible.Root>
  );
}
